// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.PrintStatementsRequest */
/* istanbul ignore next */
@GandalfModel
export class PrintStatementsRequest extends GandalfModelBase {

	@GandalfLabel('Due Date Text')
	@GandalfProperty({ designType: String })
	dueDateText!: string | null;

	@GandalfConstantDecorator(constants.StatementFormat)
	@GandalfLabel('Format')
	@GandalfValidator({ notNull: { message: 'Format is required' } })
	@GandalfProperty({ designType: constants.StatementFormat, isRequired: true })
	format!: constants.StatementFormat;

	@GandalfLabel('Message Text')
	@GandalfProperty({ designType: String })
	messageText!: string | null;

	@GandalfLabel('Print Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	printDate!: Date | null;

}
